/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountDialog extends SiteEntityDialog<AccountRow, any> {
        protected getFormKey() { return AccountForm.formKey; }
        protected getIdProperty() { return AccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRow.localTextPrefix; }
        protected getNameProperty() { return AccountRow.nameProperty; }
        protected getService() { return AccountService.baseUrl; }

        protected form = new AccountForm(this.idPrefix);

        constructor(opt: any) {
            super(opt);

            this.form.ManagerCode.onInitNewEntity = (n) => {
                n.PartyRoles = ["SUB_ADVISER"];
                n.PartyCode = Q.trimToNull(n.PartyCode);
            };

            var grpTab = this.form.AccountGroups.element.closest('.tab-pane');
            var verTab = this.form.CreatedBy.element.closest('.tab-pane');
            grpTab.insertBefore(verTab);
            var propTabs = grpTab.closest('.property-panes').prevAll('.property-tabs');
            $('a[href="#' + grpTab.attr('id') + '"]', propTabs).closest('li').insertBefore(
                $('a[href="#' + verTab.attr('id') + '"]', propTabs).closest('li'));
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons.push({
                cssClass: 'values-button',
                icon: 'fa-money',
                title: 'Account Values',
                onClick: () => {
                    var dlg = new AccountValuesDialog();
                    dlg.grid.accountCode = this.entity.AccountCode;
                    dlg.dialogTitle = 'Account Values: ' + this.entity.AccountCode;
                    dlg.dialogOpen();
                }
            });

			buttons.push({
				cssClass: 'holding-button',
				icon: 'fa-building-o',
				title: 'Holdings',
				onClick: () => {
					var dlg = new SingleAccountHoldingDialog();
					dlg.grid.accountCode = this.entity.AccountCode;
					dlg.dialogTitle = 'Account Holdings: ' + this.entity.AccountCode;
					dlg.dialogOpen();
				}
			});

            buttons.push({
				cssClass: 'history-button',
				icon: 'mdi mdi-history',
				title: 'History',
				onClick: () => {
					var dlg = new DataAudit.SingleAccountHistoryDialog();
					dlg.grid.accountCode = this.entity.AccountCode;
					dlg.dialogTitle = 'Account History: ' + this.entity.AccountCode;
					dlg.dialogOpen();
				}
			});

            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('values-button').toggle(this.isEditMode());
            this.toolbar.findButton('holding-button').toggle(this.isEditMode());
            this.toolbar.findButton('history-button').toggle(this.isEditMode());
        }      
    }
}